export const styles = {
  date_item: {
    //position: 'absolute',
    //right:20,
    //bottom:14,
    color: "#9B9B9B",
    float: "right",
    fontSize: 12,
    width: "100%",
    // paddingTop:"5px",
    textAlign: "right",
  },
  rate_item: {
    position: "absolute",
    left: "50%",
    bottom: 0,
    color: "#9B9B9B",
    //float:'right',
  },
};
